import { render, staticRenderFns } from "./ViewInstructorsPage.vue?vue&type=template&id=745d0262&scoped=true"
import script from "./ViewInstructorsPage.vue?vue&type=script&lang=ts"
export * from "./ViewInstructorsPage.vue?vue&type=script&lang=ts"
import style0 from "./ViewInstructorsPage.vue?vue&type=style&index=0&id=745d0262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d0262",
  null
  
)

export default component.exports